import React from 'react'
import PropTypes from 'prop-types'
import { routesByValue } from 'helpers/routesConstant'
import muiThemeable from 'material-ui/styles/muiThemeable'
import { compose } from 'recompose'
import withIntl from 'store/intl/withIntl'
import { withRouter } from 'react-router'
import { withStoreLocatorPreferences } from 'store/preferences/withPreferences'
import HeaderContent from 'components/headers/HeaderContent'
import Container from 'components/Container'
import Sticky from 'components/Sticky'
import PageContent from 'components/wrappers/PageContent'
import CustomTabs from 'components/Tabs/CustomTabs'
import tabTypes from './constants/TabTypes'

const getDefaultTabValue = (pathname) => {
  if (pathname.includes('stores')) {
    return tabTypes.stores
  }
  if (pathname.includes('types')) {
    return tabTypes.types
  }
  return tabTypes.brands
}

const StoreLocator = ({
  storeLocatorPreferences: {
    showTypes = false,
  },
  muiTheme: {
    palette,
  },
  children,
  location: { pathname },
  router,
}) => (
  <div>
    <Sticky>
      <HeaderContent label={routesByValue.storeLocator.label} />
      <div style={{ backgroundColor: palette.primary1Color }}>
        <CustomTabs
          defaultTabValue={getDefaultTabValue(pathname)}
          onTouchTab={(value) => router.push(`${routesByValue.storeLocator.value}/${value}`)}
        >
          <CustomTabs.Tab
            tabValue={tabTypes.stores}
            tabLabel="Stores"
            primary
            size="medium"
            borderStyle={{ borderBottom: `3px solid ${palette.accent1Color}` }}
          />
          {showTypes && (
            <CustomTabs.Tab
              tabValue={tabTypes.types}
              tabLabel="Types"
              primary
              size="medium"
              borderStyle={{ borderBottom: `3px solid ${palette.accent1Color}` }}
            />
          )}
        </CustomTabs>
      </div>
    </Sticky>
    <Container>
      <PageContent>
        {children}
      </PageContent>
    </Container>
  </div>
)

StoreLocator.propTypes = {
  children: PropTypes.node.isRequired,
  muiTheme: PropTypes.object,
  storeLocatorPreferences: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
}

StoreLocator.defaultProps = {
  muiTheme: {},
}

export default compose(
  withIntl(),
  withRouter,
  muiThemeable(),
  withStoreLocatorPreferences(),
)(StoreLocator)



// WEBPACK FOOTER //
// ./src/pages/StoreLocator/StoreLocator.js